import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Se una richiesta admin scade/invalida (401), pulisci il token e torna al login
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const sentAdmin = !!error?.config?.headers?.["X-Admin-Token"];
    if (status === 401 && sentAdmin) {
      localStorage.removeItem("admin_token");
      if (window.location.pathname.startsWith("/admin") && !window.location.pathname.includes("/reset")) {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(error);
  }
);

export const getProducts = () =>
  api
    .get("/products", { params: { _: Date.now() }, headers: { "Cache-Control": "no-cache" } })
    .then((r) => r.data);
export const getProduct = (id) => api.get(`/products/${id}`).then((r) => r.data);

export const adminLogin = (password) =>
  api.post("/admin/login", { password }).then((r) => r.data);

const adminHeaders = () => ({
  headers: { "X-Admin-Token": localStorage.getItem("admin_token") || "" },
});

export const createProduct = (data) =>
  api.post("/products", data, adminHeaders()).then((r) => r.data);
export const updateProduct = (id, data) =>
  api.put(`/products/${id}`, data, adminHeaders()).then((r) => r.data);
export const deleteProduct = (id) =>
  api.delete(`/products/${id}`, adminHeaders()).then((r) => r.data);

export const checkout = (items, origin_url, invoice, discount_code) =>
  api.post("/payments/checkout", { items, origin_url, invoice, discount_code }).then((r) => r.data);
export const paymentStatus = (sessionId) =>
  api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const validateDiscount = (code, subtotal) =>
  api.post("/discounts/validate", { code, subtotal }).then((r) => r.data);

export const getDiscounts = () =>
  api.get("/discounts", adminHeaders()).then((r) => r.data);
export const createDiscount = (data) =>
  api.post("/discounts", data, adminHeaders()).then((r) => r.data);
export const updateDiscount = (id, data) =>
  api.put(`/discounts/${id}`, data, adminHeaders()).then((r) => r.data);
export const deleteDiscount = (id) =>
  api.delete(`/discounts/${id}`, adminHeaders()).then((r) => r.data);

export const updateOrderStatus = (sessionId, status) =>
  api.put(`/orders/${sessionId}/status`, { status }, adminHeaders()).then((r) => r.data);
export const archiveOrder = (sessionId, archived) =>
  api.put(`/orders/${sessionId}/archive`, { archived }, adminHeaders()).then((r) => r.data);
export const deleteOrder = (sessionId) =>
  api.delete(`/orders/${sessionId}`, adminHeaders()).then((r) => r.data);
export const cleanupPendingOrders = () =>
  api.delete("/orders/cleanup/pending", adminHeaders()).then((r) => r.data);
export const exportOrdersCsv = () =>
  api.get("/orders/export", { ...adminHeaders(), responseType: "blob" }).then((r) => r.data);

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const updateSettings = (data) =>
  api.put("/settings", data, adminHeaders()).then((r) => r.data);

export const getSocialAssets = () =>
  api.get("/social/assets").then((r) => r.data);
export const socialDownloadUrl = (slug) => `${API}/social/download/${slug}`;
export const socialDownloadAllUrl = () => `${API}/social/download-all`;

export const getActiveFestival = () =>
  api.get("/festivals/active").then((r) => r.data);
export const getFestivals = () =>
  api.get("/festivals", adminHeaders()).then((r) => r.data);
export const updateFestival = (slug, data) =>
  api.put(`/festivals/${slug}`, data, adminHeaders()).then((r) => r.data);
export const festivalDownloadUrl = (slug) => `${API}/festivals/download/${slug}`;

export const getEmailConfig = () =>
  api.get("/email/config", adminHeaders()).then((r) => r.data);
export const updateEmailConfig = (data) =>
  api.put("/email/config", data, adminHeaders()).then((r) => r.data);
export const sendTestEmail = (to) =>
  api.post("/email/test", { to }, adminHeaders()).then((r) => r.data);

export const getOrders = (orderStatus, archived) =>
  api.get("/orders", { ...adminHeaders(), params: { ...(orderStatus ? { order_status: orderStatus } : {}), ...(archived ? { archived: true } : {}) } }).then((r) => r.data);
export const sendContact = (data) =>
  api.post("/contact", data).then((r) => r.data);

export const adminLogout = () =>
  api.post("/admin/logout", {}, adminHeaders()).then((r) => r.data);
export const adminChangePassword = (current_password, new_password) =>
  api.post("/admin/change-password", { current_password, new_password }, adminHeaders()).then((r) => r.data);
export const adminRecover = (origin_url) =>
  api.post("/admin/recover", { origin_url }).then((r) => r.data);
export const adminResetPassword = (token, new_password) =>
  api.post("/admin/reset-password", { token, new_password }).then((r) => r.data);
export const getSecurityConfig = () =>
  api.get("/admin/security", adminHeaders()).then((r) => r.data);
export const updateSecurityConfig = (data) =>
  api.put("/admin/security", data, adminHeaders()).then((r) => r.data);
